module.exports = __webpack_public_path__ + "img/duankou_1.9d155f25.png";